import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function UserChatBubbleReactionPill({ emoji, count, bySelf, onSelect }) {
  return (
    <Tooltip text={bySelf ? 'Remove your reaction' : 'Add this reaction'} placement="top">
      <button
        type="button"
        className={`${styles.reactionPill} ${bySelf ? styles.reactionPillSelf : ''}`}
        aria-label={`${emoji}${count > 1 ? `, ${count} reactions` : ''}${bySelf ? ', your reaction' : ''}`}
        onClick={() => onSelect(emoji)}
      >
        <span className={styles.reactionPillEmoji} aria-hidden>
          {emoji}
        </span>
        {count > 1 ? (
          <span className={`${styles.reactionPillCount} ${bySelf ? styles.reactionPillCountSelf : ''}`}>
            {count}
          </span>
        ) : null}
      </button>
    </Tooltip>
  )
}
